export const DELETE_SERVICE_ACCOUNT_NAME = "delete_service_account" as const;

export const DELETE_SERVICE_ACCOUNT_DESC = `Unregisters a service account from the current workspace.

Use this tool when the user asks to delete/remove/unregister a service account
(including requests like "Delete Service Account for Index Worker").
This tool unregisters the service account itself, not individual Search Console properties.
Final user approval is handled by native tool approval.

Input:
- 'serviceAccountId': immutable internal ID of the service account to unregister (do not put an email here).
- Native approval requires the concrete ID so execution is bound to the account the user reviewed.
- Email lookup remains accepted only for persisted legacy requests; do not create a new email-based approval request.

Output:
- Returns the unregistered service account id/email and related Index Worker references when available.

Notes:
- Write operation. User confirmation required.`;
